// extracted by mini-css-extract-plugin
export default {"active":"NavLinkItems_active__1F4E+"};